import * as React from 'react';

import type {EnrichmentResponse} from 'nutshell-graphql-types';

import {DataNoticePopover} from '../data-notice-popover/data-notice-popover';
import {
    ReviewEnrichmentDataModal,
    type EnrichmentResponseStatus,
} from '../review-enrichment-data-modal/review-enrichment-data-modal';

import {useGetAccountEnrichment, useAccountEnrichmentRespond} from './graphql/hooks';

type Props = {
    accountId: string;
    companyName: string | null | undefined;
};

export function CompanyEnrichmentWrapper(props: Props) {
    const [isShowingModal, setIsShowingModal] = React.useState<boolean>(false);
    const [isPopoverDismissed, setIsPopoverDismissed] = React.useState<boolean>(false);
    const [actionStatus, setActionStatus] = React.useState<
        EnrichmentResponseStatus | null | undefined
    >(undefined);

    const {accountEnrichment} = useGetAccountEnrichment(props.accountId);

    const {accountEnrichmentRespond, error, loading} = useAccountEnrichmentRespond(props.accountId);

    const onAccountEnrichmentRespond = (response: EnrichmentResponse) => {
        setActionStatus(response);
        accountEnrichmentRespond(response)
            .then(() => {
                setIsPopoverDismissed(true);
                if (response === 'ACCEPTED') {
                    window.location.reload();
                }
            })
            .catch(() => {
                setActionStatus('ERROR');
            });
    };

    if (!accountEnrichment) {
        return null;
    }

    return (
        <>
            {!isPopoverDismissed && (
                <DataNoticePopover
                    entityName={
                        props.companyName ? <strong>{props.companyName}</strong> : 'this company'
                    }
                    onClickReview={() => {
                        setIsShowingModal(true);
                    }}
                    onClickDismiss={() => {
                        setIsPopoverDismissed(true);
                    }}
                />
            )}

            {isShowingModal && (
                <ReviewEnrichmentDataModal
                    entityName={props.companyName}
                    onClose={() => setIsShowingModal(false)}
                    data={accountEnrichment}
                    additionalFields={{
                        socialFields: null,
                        companyFields: null,
                    }}
                    onSave={() => {
                        onAccountEnrichmentRespond('ACCEPTED');
                    }}
                    onDecline={() => {
                        onAccountEnrichmentRespond('DECLINED');
                    }}
                    error={error}
                    loading={loading}
                    actionStatus={actionStatus}
                    setActionStatus={setActionStatus}
                />
            )}
        </>
    );
}
